import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';

function GamesPreview_() {

    const { url } = useParams();
    const name = window.location.search.replace('?', '');
    // const searchParams = new URLSearchParams(window.location.search.replace('?', ''));
    // const gameName = searchParams.get('name');

    const [state, setState] = useState([]);
    console.log(name, "========name");
    console.log(url, "========url");


    const searchParams = new URLSearchParams(window.location.search);
    const gameUrl = searchParams.get("url");
    const gameName = searchParams.get("name");


    return (
        <div>
            <Helmet>
                {/* <!-- Title and Description --> */}
                <title>{`Play ${gameName} Online | thegameszone – Free Online Games`}</title>
                <meta name="description" content={`${gameName} | thegameszone`} />

                {/* <!-- Keywords for SEO --> */}
                <meta name="keywords" content={`play ${gameName} online, free ${gameName} game, ${gameName} game preview, online games, TheGameZone`} />

                <meta property="og:title" content={`Play ${state?.name?.en} Online | thegameszone – Free Game Preview`} />
                <meta property="og:description" content={`Discover ${state?.name?.en} on thegameszone! ${state?.description?.en} Enjoy this game and many more for free online.`} />
            </Helmet>

            {/* <iframe src={name} title={'games'} allow="autoplay" className='w-screen h-screen' /> */}
            <iframe src={decodeURIComponent(gameUrl)} title={'games'} allow="autoplay" className='w-screen h-screen' />

        </div>
    )
}

export default GamesPreview_